import moment from 'moment'
import { cognitoUserStatus } from '../../constants/amplify-api-constants'
import { userManagementConstants } from '../../constants/user-management-constants'
import Constants from '../../constants/en.json'

export function getUserStatus(user) {
  let status
  /* When the user is invited and signed up */
  if (user?.Enabled && user.UserStatus === cognitoUserStatus.CONFIRMED) {
    status = userManagementConstants.userStatus.ACTIVE
  }
  /* When the user is invited and not signed up */
  if (user?.Enabled && user.UserStatus === cognitoUserStatus.FORCE_CHANGE_PASSWORD) {
    status = userManagementConstants.userStatus.INVITED
  }
  /* When the user is disabled and signed up */
  if (!user?.Enabled && user.UserStatus === cognitoUserStatus.CONFIRMED) {
    status = userManagementConstants.userStatus.DEACTIVATED
  }
  /* When the user is disabled and not signed up */
  if (!user?.Enabled && user.UserStatus === cognitoUserStatus.FORCE_CHANGE_PASSWORD) {
    status = userManagementConstants.userStatus.DEACTIVATED
  }
  return status
}

/* Formats users from Amplify API */
export function formatListAllUsersV1(allUsers) {
  return allUsers?.map((user) => ({
    id: user.Username,
    firstName: user.Attributes.find((attr) => attr.Name === 'custom:firstName')
      ? user.Attributes.find((attr) => attr.Name === 'custom:firstName').Value
      : Constants.NONE,
    lastName: user.Attributes.find((attr) => attr.Name === 'custom:lastName')
      ? user.Attributes.find((attr) => attr.Name === 'custom:lastName').Value
      : Constants.NONE,
    clientName: user.Attributes.find((attr) => attr.Name === 'custom:clientName')
      ? user.Attributes.find((attr) => attr.Name === 'custom:clientName').Value
      : Constants.NONE,
    email: user.Attributes.find((attr) => attr.Name === 'email')
      ? user.Attributes.find((attr) => attr.Name === 'email').Value
      : Constants.NONE,
    role: user.Attributes.find((attr) => attr.Name === 'custom:userType')
      ? user.Attributes.find((attr) => attr.Name === 'custom:userType').Value
      : 'Client',
    appName: user.Attributes.find((attr) => attr.Name === 'custom:appName')
      ? user.Attributes.find((attr) => attr.Name === 'custom:appName').Value
      : Constants.NONE,
    dateAdded: moment.utc(user.UserCreateDate).format('YYYY-MM-DD'),
    status: getUserStatus(user),
    addedBy: user.Attributes.find((attr) => attr.Name === 'custom:invitedBy')
      ? user.Attributes.find((attr) => attr.Name === 'custom:invitedBy').Value
      : Constants.NOT_APPLICABLE,
  }))
}

/* Formats users from User Microservice */
export function formatListAllUsersV2(allUsers) {
  return allUsers?.map((user) => ({
    id: user?.userName,
    userName: user.userName,
    firstName: user?.firstName || Constants.NONE,
    lastName: user?.lastName || Constants.NONE,
    clientName: user?.clientName || Constants.NONE,
    email: user?.email || Constants.NONE,
    role: getAllRoleDescriptions(user?.roles),
    appName: user?.appName || Constants.NONE,
    dateAdded:
      (user?.dateAdded && moment.utc(user?.dateAdded).format('YYYY-MM-DD')) ||
      Constants.UNAVAILABLE,
    status: user?.status,
    addedBy: user?.invitedBy || Constants.NOT_APPLICABLE,
  }))
}

function getAllRoleDescriptions(roles) {
  const roleDescriptions = roles?.map((role) => role.roleDescription)
  return roleDescriptions?.join(',') || Constants.NONE
}
